// extracted by mini-css-extract-plugin
module.exports = {"distribution":"DistributionPage_distribution__2KCR5","chart":"DistributionPage_chart__pKwWv"};